import { format, isValid, parse } from 'date-fns';
import { DateInput as ReactAdminDateInput, DateInputProps as ReactAdminDateInputProps } from 'react-admin';
import {} from 'rrule/dist/esm/dateutil';

export type DateInputProps = ReactAdminDateInputProps;

export const DATE_FORMAT = 'yyyy-MM-dd';

const dateFormatter = (value: Date): string | undefined => {
  if (value == null) {
    return undefined;
  }
  if (typeof value === 'string') {
    value = new Date(value);
  }
  if (!isValid(value)) {
    return undefined;
  }
  return format(value, DATE_FORMAT);
};

const dateParser = (value: string): Date | null => {
  //value is a string of "YYYY-MM-DD" format
  if (value == null) return null;
  const date = parse(value, DATE_FORMAT, new Date());
  return isValid(date) ? date : null;
};

export const DateInput: React.FC<DateInputProps> = ({ format = dateFormatter, parse = dateParser, ...restProps }) => {
  return <ReactAdminDateInput format={format} parse={parse} {...restProps} translate="no" />;
};
